export default {
      id: "common__stationary_unit-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__stationary_unit",
      toString: function () {
        return this.url;
      }
    }